// extracted by mini-css-extract-plugin
export default {"BottomContact":"BottomContact_BottomContact__IkGqt","ContactHeader":"BottomContact_ContactHeader__lCsKB","Image":"BottomContact_Image__LBaUE","Email":"BottomContact_Email__D0AtA"};